import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { triggerNotification } from '../../../helpers/notification';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import StoreBundleTable from './StoreBundleTable';
import StoreBundleEditView from './StoreBundleEditView';

const StoreBundlesView = () => {
  const { state: authState } = useContext(AuthContext);
  const { fetchStoreProductOptions } = useContext(StoreContext);

  useEffect(() => {
    if (authState.pkEcomStore) {
      fetchStoreProductOptions(authState.pkEcomStore, {}, null, (error) => {
        triggerNotification(error);
      });
    }
  }, [authState.pkEcomStore]);

  return (
    <Routes>
      <Route element={<StoreBundleEditView />} path="/new" />
      <Route
        element={<StoreBundleEditView />}
        path="/:pkEcomStoreProductPackage"
      />
      <Route
        element={<StoreBundleEditView duplicate />}
        path="/:pkEcomStoreProductPackage/duplicate"
      />
      <Route element={<StoreBundleTable />} path="/" />
      <Route
        element={<Navigate replace to="/merchant/product-bundles" />}
        path="*"
      />
    </Routes>
  );
};

export default StoreBundlesView;
